import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import s from './Tab.module.scss';

export interface TabProps {
  selected?: boolean;
  id?: HTMLAttributes<HTMLButtonElement>['id'];
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

const Tab: FC<React.PropsWithChildren<React.PropsWithChildren<TabProps>>> = ({ selected = false, id, onClick, children }) => {
  return (
    <div className={cn(s.tab, selected ? s.selected : s.unselected)}>
      <button id={id} type="button" onClick={onClick}>
        {children}
      </button>
    </div>
  );
};

export default Tab;
